import { Box, DialogContent, DialogTitle, Divider, IconButton, Modal, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { TableReports } from "../TableReports/TableReports";
import CloseIcon from "@mui/icons-material/Close";
import { ModalRequestReport } from "../TableReports/ModalRequestReport";

interface IModalReportProps {
	isOpenModal: boolean;
	onClose: () => void;
	onclickConfirm?: () => void;
	overrideWidthValue?: string;
	overrideHeightValue?: string;
	triggerRefresh?: boolean;
	onRefreshComplete?: () => void;
}

export const ModalReport: React.FC<IModalReportProps> = ({
	isOpenModal,
	onClose,
	onclickConfirm,
	overrideWidthValue,
	overrideHeightValue,
	triggerRefresh,
	onRefreshComplete,
}) => {
	const [refreshKey, setRefreshKey] = useState(0);
	const [isOpenRequestModal, setIsOpenRequestModal] = useState(false);

	useEffect(() => {
		if (triggerRefresh) {
			setRefreshKey((prev) => prev + 1);
			onRefreshComplete?.();
		}
	}, [triggerRefresh]);

	const handleOpenRequest = () => setIsOpenRequestModal(true);
	const handleCloseRequest = () => setIsOpenRequestModal(false);

	const handleReportCreated = () => {
		setRefreshKey((prev) => prev + 1); // atualiza a tabela
		setIsOpenRequestModal(false); // fecha o modal
	};

	const style = {
		position: "absolute" as const,
		top: "50%",
		left: "50%",
		transform: "translate(-50%, -50%)",
		width: overrideWidthValue || "70%",
		height: overrideHeightValue || "auto",
		maxWidth: "80%",
		maxHeight: "90%",
		bgcolor: "background.paper",
		border: "1px solid #605e5e",
		boxShadow: 24,
		borderRadius: "8px",
		display: "flex",
		flexDirection: "column",
		backgroundColor: "#FFF",
	};

	return (
		<>
			<Modal open={isOpenModal} onClose={onClose}>
				<Box sx={style}>
					<DialogTitle sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", pb: 1 }}>
						<Typography variant="h5" fontWeight={300} color="primary.main">
							Relatórios Solicitados
						</Typography>
						<IconButton onClick={onclickConfirm || onClose} size="small">
							<CloseIcon />
						</IconButton>
					</DialogTitle>

					<Divider />

					<DialogContent sx={{ px: 3,pb:3,pt:0 }}>
						<TableReports
							key={refreshKey}
							actionDownload={() => {}}
							actionView={() => {}}
							isloading={false}
							showDownload={true}
							showView={false}
							onRequestReport={handleOpenRequest} // botão já existente na toolbar
						/>
					</DialogContent>
				</Box>
			</Modal>

			{isOpenRequestModal && (
				<ModalRequestReport
					isOpenModal={isOpenRequestModal}
					isCloseModal={handleCloseRequest}
					onclickCloseModal={handleCloseRequest}
					onReportCreated={handleReportCreated}
				/>
			)}
		</>
	);
};
